import { store } from '@/store';

export default {
	//изменение записи
	finance_putfinance(data, vue) {
		if (typeof store.state.finance.operations != 'undefined') {
			store.state.finance.operations.forEach((operation, index) => {
				if (operation.id == data.data.id) store.commit('setStateObject', ['finance.operations.' + index, data.data]);
			})
      vue.$root.$emit('refresh-table', 'operations')
		}
	},

  //удаление записи
  finance_deletefinance(data, vue) {
    if (typeof store.state.finance.operations != 'undefined') {
      vue.$root.$emit('refresh-table', 'operations');
    }
  },

  //добавление записи
  finance_postfinance(data, vue) {
    if (typeof store.state.finance.operations != 'undefined') {
      vue.$root.$emit('refresh-table', 'operations');
    }
  },
}


// WEBPACK FOOTER //
// ./src/modules/finance/pusher.js